export default "__VITE_ASSET__9jjOpXIH__"